export default __webpack_public_path__ + "static/media/FontsFree-Net-SFProText-Light.8313687a.ttf";